export const OrderLabelViewLabels = {
    courierLabels: 'Guías de paquetera',
    labels: 'Información de guías',
    matchedGuides: 'Guías asociadas',
    noInfo: 'Sin información',
    whiteLabels: 'Guías blancas',
    empty_string: '',
    percentage: '%',
  };
